import { render, staticRenderFns } from "./ProjectDocumentTemplateDetailEdit.vue?vue&type=template&id=46ad1ad7"
import script from "./ProjectDocumentTemplateDetailEdit.vue?vue&type=script&lang=js"
export * from "./ProjectDocumentTemplateDetailEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports